import Keycloak from 'keycloak-js';
import { useAuthStore } from "../store/auth-store";
import { useConfigStore } from "../store/config-store";

import { storeToRefs } from "pinia";
const VUE_APP_KEYCLOAK_API_BASE_URL = process.env.VUE_APP_KEYCLOAK_API_BASE_URL || "http://localhost:8089".replace(/\/+$/, "");

const VUE_APP_KEYCLOAK_REALM = process.env.VUE_APP_KEYCLOAK_REALM || "cleverroute";
const VUE_APP_KEYCLOAK_CLIENT_ID = process.env.VUE_APP_KEYCLOAK_CLIENT_ID ||  "cleverreach-app-authentication";

const options = {
  url: VUE_APP_KEYCLOAK_API_BASE_URL,
  clientId: VUE_APP_KEYCLOAK_CLIENT_ID,
  realm: VUE_APP_KEYCLOAK_REALM
}

const keycloak = new Keycloak(options);
let data;
// let authenticated;
// let store = null;

let authenticated = false;
/**
 * Initializes store with Keycloak user data
 *
 */
async function saveLoginKeycloak(userData) {
  try {

    useAuthStore().storeLogin(keycloak, userData)

    // Show alert if user is not authenticated
    if (!authenticated) {
      return false;
    }
  } catch (error) {
    console.error("Keycloak init failed: ", error)
    return false;
  }
};

async function initKeycloak() {
  await keycloak.init({ onLoad: 'check-sso', enableLogging: true }).then((authenticated) => {
    if (authenticated) {
      console.log("initKeycloak-user authenticated");
      // save user-details in local store
      keycloak.loadUserProfile().then(userData => {
        console.log("userprofile=", userData);
        saveLoginKeycloak(userData);
        useAuthStore().fetchUserData(userData.id);
        useConfigStore().fetchTransportsOfUser(userData.id);
        useConfigStore().fetchVehiclesSpecOfUser(userData.id);
    })

      // load user-related config from server
      
    } else {
      console.log("initKeycloak-user NOT authenticated")

      // handle failed authentication
    }
  }).catch(err => {
    console.log("initKeycloak-error:", err)
  });
}

async function loginKeycloak() {
  keycloak.login().then(d => {
    console.log("login: ", d);
    saveLoginKeycloak();
  }).catch(err => console.log("login-err=", err));
}

/**
 * Initializes Keycloak, then run callback. This will prompt you to login.
 *
 * @param onAuthenticatedCallback
 */
async function loginKeycloakOld() {
  try {
    // keycloak = new Keycloak(options);

    //  keycloak.init({
    //   promiseType: 'native',
    //   // enableLogging: true,
    //   // checkLoginIframe: false,
    //   onLoad: 'login-required'
    // }).then(d => {
    //   console.log("data=",d);
    // data=d}).catch(err => data=err);

    let authenticated = await keycloak.init({
      enableLogging: true,
      checkLoginIframe: false,
      onLoad: 'login-required',
    });
    // console.log("is authenticated=", authenticated, keycloak)
    if (authenticated) {
      return true;

    } else {
      return false;
    }
    // onInitCallback()
  } catch (error) {
    console.error("Keycloak init failed: ", error);
    return false;
  }
};
/**
 * Logout user
 */
async function logoutKeycloak() {
  const authStore = useAuthStore();
  const keycloakObj = authStore.getKeycloakObj;
  console.log("authStore.clearUserData()");

  authStore.clearUserData();
  keycloakObj
    .logout()
    .then((val) => {
      console.log("logged out-val=", val);
    })
    .catch((err) => console.log("error when logging out: ", err));
}

/**
 * Refreshes token
 */
async function refreshKeycloakToken() {
  try {
    await keycloak.updateToken(480);
    return keycloak;
  } catch (error) {
    console.error('Failed to refresh token');
    console.error(error);
  }
}

const KeycloakService = {
  initKeycloak: initKeycloak,
  loginKeycloak: loginKeycloak,
  logoutKeycloak: logoutKeycloak,
  refreshKeycloakToken: refreshKeycloakToken,
  keycloakObj: keycloak,
  authenticated: authenticated,
  data
};

export default KeycloakService;